@if (dataLayer && dataLayerType) {
  <div
    class="flex gap-2 white-space-nowrap"
    [ngClass]="{
      'p-button-xs p-button p-button-secondary p-button-text p-button-raised p-button-rounded':
        !readonly,
    }"
    (click)="menu.toggle($event)">
    <!--<app-data-layer-type-icon
      [dataLayerType]="dataLayerType"></app-data-layer-type-icon>-->
    <span>{{ dataLayerType.name + ': ' + feature?.name }}</span>
    @if (!readonly) {
      <i class="fas fa-chevron-down text-xs"></i>
    }
  </div>
  <p-tieredMenu appendTo="body" #menu [model]="featureMenu" [popup]="true" />
}
